import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Bus/Get`, payload),
    GetBusStopDetail: (payload) => Repository.post(`/api/Bus/GetBusStopDetail`, payload),
    GetBusVehicleCurrent: (payload) => Repository.post(`/api/Bus/GetBusVehicleCurrent`, payload),
    Dashboard: (payload) => Repository.post(`/api/Bus/Dashboard`, payload),
}